import React from "react";

import "./ProgressBar.css";

const ProgressBar = ({ uploadedCount, fileCount }) => {
    return (
        <div className="Progress">
            <div className="ProgressString">{`${uploadedCount} / ${fileCount}`}</div>
            <div className="ProgressBarBack">
                <div className="ProgressBarLive" style={{ width: (uploadedCount * 100) / fileCount + "%" }} />
            </div>
        </div>
    );
};

export default ProgressBar;
